import initialState from './state.js'

const STATE_TO_NOT_RESET = ['measureUnits']

export default {
  RESET_PRODUTOS_MODULE(state) {
    Object.keys(initialState).forEach((key) => {
      if (STATE_TO_NOT_RESET.includes(key)) return
      state[key] = initialState[key]
    })
  },
  SET_MEASURES_UNITS(state, payload) {
    state.measureUnits = payload
  },
}
